<template>
  <div
    class="pageTips"
    :style="{
      'background-color': tipsType == 'empty-minapp' ? '#F7F7FF' : (category.text == '加载中' ? '#4C4C4C' : '#fff'),
    }"
  >
    <div class="box">
      <div class="layui-m-layercont" v-if="category.text == '加载中'">
        <i></i><i class="layui-m-layerload"></i><i></i>
      </div>
      <img
        v-if="category.text != '加载中'"
        :src="category.img"
        :class="tipsType == 'empty-minapp' ? 'empty-minapp-img' : ''"
      />
      <div
        :class="tipsType == 'empty-minapp' ? 'empty-minapp-txt' : ''"
        :style="{ color: category.text == '加载中' ? '#fff' : '#b1bfcd' }"
      >
        {{ emptyTxt || category.text }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "pageTips",
  props: {
    tipsType: {
      type: String,
      value: "",
    },
    emptyTxt: {
      type: String,
      value: "",
    },
  },
  data() {
    return {
      categories: {
        loading: {
          img:
            "https://resource.tuixb.cn/beta/00000000-0000-0000-0000-000000000000/KMA/miniapp/cover-loading.png",
          text: "加载中",
        },
        empty: {
          img:
            "https://resource.tuixb.cn/beta/00000000-0000-0000-0000-000000000000/KMA/miniapp/cover-data-empty.png",
          text: "这里空空如也，小宝没有找到内容~",
        },
        "error-data": {
          img:
            "https://resource.tuixb.cn/beta/00000000-0000-0000-0000-000000000000/KMA/miniapp/cover-data-error.png",
          text: "抱歉，小宝有点开小差",
        },
        "empty-data": {
          img:
            "https://resource.tuixb.cn/beta/00000000-0000-0000-0000-000000000000/KMA/miniapp/cover-data-error.png",
          text: "该文章已不存在",
        },
        "delete-data": {
          img:
            "https://resource.tuixb.cn/beta/00000000-0000-0000-0000-000000000000/KMA/miniapp/cover-data-error.png",
          text: "该文章已删除",
        },
        "error-network": {
          img:
            "https://resource.tuixb.cn/beta/00000000-0000-0000-0000-000000000000/KMA/miniapp/cover-network-error.png",
          text: "网络异常",
        },
        "empty-minapp": {
          img:
            "https://resource.tuixb.cn/beta/00000000-0000-0000-0000-000000000000/KMA/default/e3d2780f-a6cd-4270-9a1d-c0f1b6893d4c.png",
          text: "数据为空",
        },
      },
      category: {},
    };
  },
  watch: {
    tipsType: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getCategory(val);
        }
      },
    },
  },
  mounted() {},
  methods: {
    getCategory(key) {
      this.category = this.categories[key] || {};
    },
  },
};
</script>
<style lang="scss" scoped>
.pageTips {
  width: 100%;
  height: 100vh;
  background-color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  .box {
    width: 560px;
    height: 100vh;
    margin: 0 auto;
    padding-top: 225px;
    box-sizing: border-box;
    text-align: center;
  }
  img {
    width: 100%;
    height: auto;
  }
  span {
    margin: 58px auto 0;
    display: block;
    font-weight: normal;
    font-family: "Microsoft Yahei";
    font-size: 22px;
    color: rgba(177, 191, 205, 1);
    text-align: center;
    overflow: hidden;
  }

  .layui-m-layercont {
    text-align: center;
    padding: 0;
    line-height: 0;
    margin-top: 260px;
  }

  .layui-m-layercont i {
    width: 52px;
    height: 52px;
    margin-left: 19px;
    display: inline-block;
    background-color: #fff;
    border-radius: 100%;
    -webkit-animation: c 1.4s infinite ease-in-out;
    animation: c 1.4s infinite ease-in-out;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
  }

  .layui-m-layercont p {
    margin-top: 47px;
  }

  @-webkit-keyframes c {
    0%,
    80%,
    to {
      transform: scale(0);
      -webkit-transform: scale(0);
    }

    40% {
      transform: scale(1);
      -webkit-transform: scale(1);
    }
  }

  @keyframes c {
    0%,
    80%,
    to {
      transform: scale(0);
      -webkit-transform: scale(0);
    }

    40% {
      transform: scale(1);
      -webkit-transform: scale(1);
    }
  }

  .layui-m-layercont i:first-child {
    margin-left: 0;
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
  }

  .layui-m-layercont i.layui-m-layerload {
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
  }

  .empty-minapp-img {
    width: 3.733rem;
  }

  .empty-minapp-txt {
    font-size: 0.347rem;
    color: #969799 !important;
    margin-top: 0.32rem;
  }
}
</style>